import { render, staticRenderFns } from "./PatientOverview.vue?vue&type=template&id=79fef4c0&scoped=true"
import script from "./PatientOverview.vue?vue&type=script&lang=ts"
export * from "./PatientOverview.vue?vue&type=script&lang=ts"
import style0 from "./PatientOverview.vue?vue&type=style&index=0&id=79fef4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fef4c0",
  null
  
)

export default component.exports